import * as angular from "angular";

export class userRequests {

  /* @ngInject */
  constructor(private UsersAPI, private $user) {
  }

  changeUserPassword(userId, password) {
    const api = this.UsersAPI.actions.changePassword;
    return this.$$call(api, {}, {password: password}, {}, userId);
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params, _data, _options, userId) {
    return this.$user(userId).$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.user')
  .service('userRequests', userRequests);
